// extracted by mini-css-extract-plugin
export default {"container":"Language_container__Ivuai","body":"Language_body__BADm0","option":"Language_option__PQmPd","active":"Language_active__Qk-yf","inactive":"Language_inactive__IUNxS"};